import React from "react";
import person2 from "../../Assets/Images/person2.png";
const Instructor = () => {
  return (
    <section className="max-w-full -mt-20 xl:-mt-12 xl:mx-8 xl:mb-10 flex flex-col md:flex-row items-center justify-center gap-12 md:gap-20 px-6 md:px-6 py-16 bg-white font-['Roboto'] ">
      <div className=" w-full md:w-1/2 flex justify-center rounded-lg  bg-gradient-to-r from-primaryColor to-secondaryColor ">
        <img
          src={person2}
          alt="Instructor smiling with thumbs up"
          className="w-full h-96 md:h-[550px] object-cover rounded-lg translate-x-1 xl:translate-x-5 -translate-y-1 xl:-translate-y-5"
        />
      </div>

      <div className="w-full md:w-1/2 space-y-6">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 font-barlow leading-snug heading">
          Come Teach with Us and <br /> Become an Instructor Today
        </h1>

        <p className="text-gray-600 text-lg sub-heading">
          Courses teach us the knowledge and skills needed to achieve our goals.
          They help us understand new concepts, develop problem-solving
          abilities, and gain practical experience. Through guided learning and
          mentor support, courses build confidence and prepare us for real-world
          challenges.
        </p>

        {/* <button className="relative w-1/2 md:w-1/3 bg-gradient-to-r from-primaryColor to-secondaryColor text-white font-bold rounded-xl py-4 overflow-hidden group transition-all duration-300">
          <span className="block transition-transform duration-500 ease-in-out group-hover:-translate-y-10">
            Get Started
          </span>
          <span className="absolute inset-0 flex items-center justify-center translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-in-out">
            Get Started
          </span>
        </button> */}
      </div>
    </section>
  );
};
export default Instructor;
